import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

import { HeaderComponent } from './header/header.component';
import { NavComponent, NavFilterPipe } from './nav/nav.component';
import { MainLayoutComponent } from './main-layout/main-layout.component';
import { AuthLayoutComponent } from './auth-layout/auth-layout.component';
import { ContractorLayoutComponent } from './contractor-layout/contractor-layout.component';
import { AccordionLinkDirective } from './nav-accordion/accordionlink.directive';
import { AccordionAnchorDirective } from './nav-accordion/accordionanchor.directive';
import { AccordionDirective } from './nav-accordion/accordion.directive';
import { ComponentsModule } from './components/components.module';
// Angular Flexlayout
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
// ngx-translate
import { TranslateModule } from '@ngx-translate/core';
// ngx-loading-bar
import { LoadingBarModule } from '@ngx-loading-bar/core';
// ngx-perfect-scrollbar
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';

import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTableModule } from '@angular/material/table';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
const routes: Routes = [];
@NgModule({
  declarations: [
    HeaderComponent,
    NavComponent,
    NavFilterPipe,
    MainLayoutComponent,
    AuthLayoutComponent,
    ContractorLayoutComponent,
    AccordionDirective,
    AccordionLinkDirective,
    AccordionAnchorDirective],
  imports: [
    RouterModule,
    TranslateModule,
    CommonModule,
    FormsModule,
    MatExpansionModule,
    MatSidenavModule,
    MatMenuModule,
    MatCheckboxModule,
    MatDialogModule,
    MatIconModule,
    MatTableModule,
    MatSnackBarModule,
    MatButtonModule,
    MatToolbarModule,
    MatTooltipModule,
    MatListModule,
    MatSelectModule,
    MatInputModule,
    MatCardModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    FlexLayoutModule,
    LoadingBarModule,
    PerfectScrollbarModule,
    ComponentsModule
  ],
  exports: [
    HeaderComponent,
    NavComponent,
    NavFilterPipe,
    MainLayoutComponent,
    AuthLayoutComponent,
    ContractorLayoutComponent,
    AccordionDirective,
    AccordionLinkDirective,
    AccordionAnchorDirective
  ]
})
export class ViasngCoreModule { }
